const state = {
  favourites: []
}

const mutations = {
  setFavourites: function (state, payload) {
    state.favourites = payload
  }
}

const actions = {
  loadFavourites: function (context, rid) {
    let favourites = []
    if (localStorage.getItem('favourites' + rid) !== null) {
      favourites = JSON.parse(localStorage.getItem('favourites' + rid))
      context.commit('setFavourites', favourites)
    }
  },
  addFavourite: function (context, athid) {
    let favourites = JSON.parse(JSON.stringify(context.state.favourites))
    favourites.push(athid)
    localStorage.setItem('favourites' + context.rootState.race.race.id, JSON.stringify(favourites))
    context.commit('setFavourites', favourites)
  },
  removeFavourite: function (context, athid) {
    let favourites = JSON.parse(JSON.stringify(context.state.favourites))
    let index = favourites.indexOf(athid)
    if (index > -1) {
      favourites.splice(index, 1)
    }
    localStorage.setItem('favourites' + context.rootState.race.race.id, JSON.stringify(favourites))
    context.commit('setFavourites', favourites)
  }
}

const getters = {
  favourites: state => {
    return state.favourites
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/favourites.js